module.exports = __webpack_public_path__ + "mask-bg.jpg?1948029c694fcd678b924050201a4009";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask-bg.jpg
// module id = 28
// module chunks = 0